import { Editor } from '@tinymce/tinymce-react';
import { Editor as Ed } from "tinymce/tinymce"

// TinyMCE so the global var exists
import 'tinymce/tinymce';
// DOM model
import 'tinymce/models/dom/model'
// Theme
import 'tinymce/themes/silver';
// Toolbar icons
import 'tinymce/icons/default';
// Editor styles
import 'tinymce/skins/ui/oxide/skin';

// importing the plugin js.
// if you use a plugin that is not listed here the editor will fail to load
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/code';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';
import 'tinymce/plugins/help/js/i18n/keynav/en';
import 'tinymce/plugins/image';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/quickbars';
import 'tinymce/plugins/save';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';

// importing plugin resources
import 'tinymce/plugins/emoticons/js/emojis';

// Content styles, including inline UI like fake cursors
import 'tinymce/skins/content/default/content';
import 'tinymce/skins/ui/oxide/content';
import { useRef } from 'react';
import { REACT_APP_API_URL } from '../../../api/base';

export default function TinyEditor({ defaultValue, onChange }: { defaultValue: string, onChange: (innerHTML: string) => void }) {
    const editorRef = useRef<null | Ed>(null);

    return (
        <>
            <Editor
                licenseKey='gpl'
                onInit={(_evt, editor) => editorRef.current = editor}
                initialValue={defaultValue}
                onEditorChange={() => { if (editorRef.current) { onChange(editorRef.current.getContent()); } }}
                init={{
                    height: "90vh",
                    menubar: false,
                    plugins: [
                        'advlist', 'anchor', 'autolink', 'code', 'codesample', 'fullscreen', 'help', 'image', 'media',
                        'link', 'lists', 'preview',
                        'searchreplace', 'table', 'wordcount'
                    ],
                    toolbar: 'searchreplace | h1 h2 h3 bold italic backcolor bullist numlist outdent indent link ' +
                        '| alignleft aligncenter alignright alignjustify' +
                        '| code codesample | table' +
                        '| removeformat | image media' +
                        '| preview | fullscreen | help',

                    audio_template_callback: (data: any) =>
                        '<audio nocontrols>\n' +
                        `<source src="${data.source}"${data.sourcemime ? ` type="${data.sourcemime}"` : ''} />\n` +
                        (data.altsource ? `<source src="${data.altsource}"${data.altsourcemime ? ` type="${data.altsourcemime}"` : ''} />\n` : '') +
                        '</audio>',
                    images_upload_url: REACT_APP_API_URL + "/upload",
                    images_upload_credentials: true,
                }}
            />
        </>
    );
}